<template>
  <div class="tab">
    <div
      class="inner"
    >
      <div
        key="content"
        class="content"
      >
        <div
          class="module"
        >
          <div
            v-if="tab && (tab.title || tab.subTitle)"
            class="titles"
          >
            <h2
              v-if="tab.title"
            >
              {{ tab.title }}
            </h2>

            <p
              v-if="tab.subTitle"
            >
              {{ tab.subTitle }}
            </p>
          </div>
          <slot />
        </div>

        <div
          class="product-info"
        >
          <div
            v-if="items.length"
            class="items"
          >
            <div
              v-for="(item, index) of items"
              :key="index"
            >
              <zg-item-solo
                :title="item.title"
                :text="item.text"
                :illustration="item.illustration"
                :link-url="item.link.href"
                :link-text="item.link.text"
                link-button
                vertical
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ZgItemSolo from '../ZgItemSolo/ZgItemSolo'
  export default {
    name: 'Tab',
    components: {
      ZgItemSolo
    },
    props: {
      tab: {
        type: Object,
        required: false,
        default: null
      }
    },
    computed: {
      items () {
        return (this.tab?.items?.slice(0, 3) || [])
          .map(item => ({
            title: item.title,
            text: item.text,
            illustration: item.illustration,
            link: {
              href: item.button?.href,
              text: item.button?.text
            }
          }))
      }
    },
    methods: {
      randomString () {
        return (Math.random() + 1).toString(36).substring(7)
      },
      setRenderHash () {
        this.renderHash = this.randomString()
      }
    }
  }
</script>

<style lang="scss" scoped>
  $max-width: rem(1080px);

  .tab {
    position: relative;
    width: 100%;
    max-width: $max-width;
    background-color: color(tabs-background);
    padding: rhythm() rhythm(small);
    margin: 0 auto;
    z-index: 10;

    @include mq(medium) {
      max-width: $max-width + (rhythm(medium) * 2);
      padding: rhythm(medium) rhythm(small);
      border-radius: rem(32px) rem(32px) 0 0;
    }

    @include mq(large) {
      max-width: $max-width + (rem(48px) * 2);
      padding: rem(48px);
      border-radius: rem(48px) rem(48px) 0 0;
    }

    .inner {
      display: flex;
      flex-direction: column;
      gap: rem(24px);

      @include mq(large) {
        gap: rem(32px);
      }
    }

    .titles,
    .content {
      width: 100%;
      max-width: $max-width;
    }

    .titles {
      margin-bottom: rhythm(xsmall);

      h2 {
        margin: 0 0 rhythm(half);
      }

      p {
        margin: 0 0 rem(8px);

        &:last-child {
          margin: 0;
        }
      }
    }

    .content {
      margin: 0 auto;
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: rem(24px);

      @include mq(large) {
        flex-direction: row;
        gap: rem(48px);
      }

      .module {
        flex-shrink: 0;
        flex-grow: 0;
        width: 100%;
        background-color: color(tabs-module-background);
        padding: rhythm();
        border-radius: rhythm(medium);
        height: fit-content;

        @include mq(large) {
          width: rem(610px);
        }
      }

      .product-info {
        flex-grow: 1;

        .illustration {
          display: none;
          height: rem(160px);
          margin: 0 0 rhythm();

          @include mq(large) {
            display: block;
          }
        }
      }
    }

    .items {
      display: flex;
      flex-direction: column;
      gap: rhythm();

      @include mq(large) {
        gap: rhythm(double);
      }

      & > div {
        width: 100%;
      }
    }
  }
</style>
